import { LoadState } from "../../constants/enums";
import { IApiKey, IApiKeyState } from "./apikey.types";

/**
 * Initial API Key form/data state
 */
export const initialApiKey: IApiKey = {
  apikey_uuid: null,
  apikey_name: "",
  api_key: "",
  apikey_source: null,

  credentials: [{ key: null, value: null }],
  response_data: [{ key: null, value: null }],

  comment: "",
  remarks: "",
  status: "ACTIVE",
  company_outlet_uuid: "",

  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: ""
};

/**
 * Initial API Key redux state
 */
export const initialApiKeyState: IApiKeyState = {
  ApiKey: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
